import { styled } from '@linaria/react'

export const Text = styled.p``

export const Link = styled.a`
  font-weight: var(--font-weight-bold);
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
`

export const Subline = styled.p`
  font-size: var(--font-size-subline);
  line-height: var(--line-height-subline);
`

export const SublineLink = styled.a`
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-subline);
  line-height: var(--line-height-subline);
`

export const HeroButton = styled.button`
  text-transform: uppercase;
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-hero-button);
  line-height: var(--line-height-hero-button);
`

export const Button = styled.button`
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-button);
  line-height: var(--line-height-button);
`

export const ButtonLight = styled.button`
  font-weight: var(--font-weight-default);
  font-size: var(--font-size-button);
  line-height: var(--line-height-button);
`

export const TagLarge = styled.span`
  text-transform: uppercase;
  font-size: var(--font-size-tag-large);
  line-height: var(--line-height-tag-large);
`

export const Tag = styled.span`
  text-transform: uppercase;
  font-size: var(--font-size-tag);
  line-height: var(--line-height-tag);
`

export const Navigation = styled.div`
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-navigation);
  line-height: var(--line-height-navigation);
`

export const Citation = styled.div`
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-citation);
  line-height: var(--line-height-citation);
`

export const Lead = styled.div`
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-lead);
  line-height: var(--line-height-lead);
`

export const Input = styled.div`
  font-size: var(--font-size-input);
  line-height: var(--line-height-input);
`

export const Label = styled.div`
  font-size: var(--font-size-label);
  line-height: var(--line-height-label);
  opacity: 0.8;
`
